<template>
<div class="wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
          <a class="btn btn-primary" v-on:click="$router.go(-1)">Tillbaka</a>
      </div>
    </div>
  </div>
  <div class="container details">
    <div class="row">
      <div class="col-md-12">
        <h1>Skapa ny order</h1>
      </div>
    </div>
    <div class="row orderDetailsWrapper">
      <div class="col-md-12">
        <form class="formGeneratorWithColumns">
          <vue-form-generator tag="div" :schema="activeSchema" :model="orderModel" />
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Map from '@/components/Map/Map'
export default {
  name: 'OrderCreate',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    Map
  },
  data () {
    return {
      schema: {},
      orderModel: {},
      activeSchema: {}
    }
  },
  mounted () {
    this.schema = this.$route.params.schema
    this.activeInputs()
    this.appendtoSchema()
    this.getCustomers()
    this.getTrucks()
    this.getArticles()
    this.setCustomerPlacesList()
  },
  methods: {
    activeInputs () {
      this.activeSchema = Object.assign({}, this.schema)
      this.activeSchema.fields = this.activeSchema.fields.filter((c) => c.activeInDetails)
    },
    appendtoSchema () {
      this.activeSchema.fields.push({
        type: 'submit',
        buttonText: 'Skapa',
        onSubmit: this.onSave,
        validateBeforeSubmit: true
      })
      this.activeSchema.fields.push({
        type: 'submit',
        buttonText: 'Avbryt',
        onSubmit: this.onCancel
      })
    },
    setCustomerPlacesList () {
      let that = this
      setTimeout(() => document.querySelector('#kund').addEventListener('change', function () {
        var customerPlacesList = document.querySelector('#leveransstlle')
        var b
        for (b = customerPlacesList.options.length - 1; b >= 0; b--) {
          if (b !== 0) { customerPlacesList.remove(b) }
        }
        that.getCustomerPlacesByCustomer(this.value)
      }), 0)
    },
    getCustomers () {
      this.$http
        .get('/api/customers')
        .then(response => {
          var customers = response.data.customers
          var customerSelect = this.schema.fields.find(field => field.model === 'kund')
          for (var i = 0; i < customers.length; i++) {
            customerSelect.values.push({'id': customers[i].id, 'name': customers[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    getTrucks () {
      var trucksSelect = this.activeSchema.fields.find(field => field.model === 'trucks')
      this.$http
        .get('/api/objectdatas/objectgroupid/2')
        .then(response => {
          var trucks = response.data
          for (var i = 0; i < trucks.length; i++) {
            if (!trucks[i].data.inActive) {
              trucksSelect.values.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr, 'type': trucks[i].ObjectDescription.name})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getArticles () {
      var articlesSelect = this.activeSchema.fields.find(field => field.model === 'articles')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/17')
        .then(response => {
          var articles = response.data
          for (var i = 0; i < articles.length; i++) {
            articlesSelect.values.push({'id': articles[i].id, 'name': articles[i].data.name, 'type': articles[i].data.type, 'ton': ''})
          }
        })
        .catch(error => console.log(error))
    },
    getCustomerPlacesByCustomer (endCustomerId) {
      var placesSelect = this.activeSchema.fields.find(field => field.model === 'CustomerPlacesDropDown')
      this.$http
        .get('/api/customersplaces/endcustomerForHydro/' + endCustomerId)
        .then(response => {
          var places = response.data.endcustomer.filter(place => place.data.inActive !== true)
          for (var i = 0; i < places.length; i++) {
            placesSelect.values.push({'id': places[i].id, 'name': places[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    onSave () {
      var url = '/api/orders'
      this.$http
        .post(url, {
          order: {
            type: 'hydro',
            state: 'godkänd',
            needsAttention: 0,
            data: this._.omit(this.orderModel, 'submit')
          }
        })
        .then(response => {
          this.$router.go(-1)
        })
        .catch(error => console.log(error))
    },
    onDelete () {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/orders/' + this.order.id
          this.$http
            .delete(url)
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onCancel () {
      this.$router.go(-1)
    },
    onFinished () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/OrderCreate.vue